<template>
  <div class="period" :class="isDisabled ? 'period_disabled' : ''">
    <div class="period__header">
      <div v-if="product" style="margin-bottom: 3px;" class="">Товар: #{{ product }}</div>
      <div v-else style="margin-bottom: 3px;" class="">Общие показатели</div>
      <div class="period__date-wrapper">
        <span class="period__date period__date-from">{{ dateFrom}}</span> -
        <span class="period__date period__date-to">{{ dateTo }}</span>
      </div>
    </div>
    <div class="period__content">

      <div style="width: calc(33.33% - 10px)" class="period__info period__purchase">
        <div class="period__info-header">
          <span>Сессии</span>
          <span class="period__popup">
            <span class="period__popup-trigger">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26px" height="26px"><path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z"/></svg>
            </span>
            <span class="period__popup-content">
              <p>Сессией на сайте считается каждый визит посетителя.</p>
              <p>В момент когда пользователь загружает страницу магазина фиксируется начало новой сессии.
                Она будет продолжаться до тех пор, пока вклада магазина не будет закрыта.</p>
              <p>Все перемещения внутри магазина происходят в рамках одной сессии</p>
              <p>Если сессия была завершена, повторное открытие страницы магазина создаст новую сессию</p>
            </span>
          </span>
        </div>
        <div class="period__info-content">
          <div class="period__info-stat">{{ statistic.calculator.sessions }}</div>
        </div>
      </div>

      <div style="width: calc(33.33% - 10px)" class="period__info period__purchase">
        <div class="period__info-header">
          <span>Просмотры</span>
          <span class="period__popup">
            <span class="period__popup-trigger">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26px" height="26px"><path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z"/></svg>
            </span>
            <span class="period__popup-content">
              <p>Просмотр равняется открытию страницы товара.</p>
              <p>Для каждого товара показатель фиксируется отдельно.</p>
            </span>
          </span>
        </div>
        <div class="period__info-content">
          <div class="period__info-stat">{{ statistic.calculator.visits }}</div>
          <span class="period__info-decor"> / </span>
          <div class="period__info-conversion">{{ getConversion(statistic.calculator.sessions, statistic.calculator.visits, 5) }}</div>
        </div>
      </div>

      <div style="width: calc(33.33% - 10px)" class="period__info period__purchase">
        <div class="period__info-header">
          <span>Доб. в корзину</span>
          <span class="period__popup">
            <span class="period__popup-trigger">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26px" height="26px"><path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z"/></svg>
            </span>
            <span class="period__popup-content">
              <p>Добавление товара в корзину</p>
              <p>При этом обновление кол-во единиц позиции в корзине или удаление позиции из корзине не влияет на данный показатель</p>
            </span>
          </span>
          <span v-if="false && ! product" style="margin-left: 10px; cursor: pointer" @click="getCartProduct">Get</span>
          <div v-if="false && ! product && cartData" class="period__product-modal">
            {{ cartData }}
          </div>
        </div>
        <div class="period__info-content">
          <div class="period__info-stat">{{ statistic.calculator.cart }}</div>
          <span class="period__info-decor"> / </span>
          <div class="period__info-conversion">{{ getConversion(statistic.calculator.visits, statistic.calculator.cart, 5) }}</div>
        </div>
      </div>

      <div style="width: calc(33.33% - 10px)" class="period__info period__purchase">
        <div class="period__info-header">
          <span>Доб. в избранное</span>
        </div>
        <div class="period__info-content">
          <div class="period__info-stat">{{ statistic.calculator.favorite }}</div>
          <span class="period__info-decor"> / </span>
          <div class="period__info-conversion">{{ getConversion(statistic.calculator.visits, statistic.calculator.favorite, 5) }}</div>
        </div>
      </div>

      <div style="width: calc(33% - 10px)" class="period__info period__purchase">
        <div class="period__info-header">Продажи</div>
        <div class="period__info-content">
          <div class="period__info-stat">{{ statistic.calculator.purchase }}</div>
          <span class="period__info-decor"> / </span>
          <div class="period__info-conversion">{{ getConversion(statistic.calculator.cart, statistic.calculator.purchase, 5) }}</div>
        </div>
      </div>

      <div style="width: calc(33% - 10px)" class="period__info period__purchase">
        <div class="period__info-header">
          <span>Конверсия</span>
          <span class="period__popup">
            <span class="period__popup-trigger">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26px" height="26px"><path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z"/></svg>
            </span>
            <span class="period__popup-content">
              <p>Конверсия - процентный показатель между количеством сессий и количеством продаж</p>
            </span>
          </span>
        </div>
        <div class="period__info-content">
          <div class="period__info-conversion">{{ getConversion(statistic.calculator.sessions, statistic.calculator.purchase, 5) }}</div>
        </div>
      </div>

    </div>

    <div class="period__tables">
      <apexchart v-if="statistic.array && statistic.array.length" :key="key" width="500px" type="area" :options="options" :series="series" />
      <apexchart v-if="statistic.array && statistic.array.length" :key="key" width="500px" :options="options2" :series="series2" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'conversion-product-period',
  data() {
    return {
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: [

          ]
        },
        colors: ['#bb37fd', '#ef4600', '#33D69F', '#6545f1', '#d6b033'],
      },
      series: [
        {
          id: 'sessions',
          name: 'Сессии',
          data: []
        },
        {
          id: 'visits',
          name: 'Просмотр товара',
          data: []
        },
        {
          id: 'cart',
          name: 'Добавление в корзину',
          data: []
        },
        {
          id: 'purchase',
          name: 'Продажа',
          data: []
        },
        {
          id: 'favorites',
          name: 'Добавление в избранное',
          data: []
        }
      ],

      series2: [
        {
          name: 'Воронка',
          data: [
            {
              x: "Сессии",
              y: this.statistic.calculator.sessions
            },
            {
              x: "Просмотр товаров",
              y: this.statistic.calculator.visits
            },
            {
              x: "Добавление в корзину",
              y: this.statistic.calculator.cart
            },
            {
              x: "Продажи",
              y: this.statistic.calculator.purchase
            }
          ]
        },
      ],
      options2: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            isFunnel: true,
          },
        },
      },
    }
  },
  props: {
    isDisabled: {
      type: Boolean
    },
    key: {
      type: Number
    },
    statistic: {
      required: true,
      type: Object
    },
    product: {
      type: String
    },
    from: {
      type: String
    },
    to: {
      type: String
    },
    insalesId: {
      type: Number
    }
  },
  computed: {
    dateFrom() {
      return this.prepareDate(this.statistic.array[0].date);
    },
    dateTo() {
      return this.prepareDate(this.statistic.array[this.statistic.array.length - 1].date);
    },

    cartData() {
      return this.$store.state.statistics.cartDate[0];
    },
  },
  methods: {
    getConversion(a, b, i) {
      if (a == 0 && b == 0) {
        return '0%';
      }

      // if (b > a) {
      //   return '∞'
      // }

      return `${(b / (a / 100)).toFixed(i || 2)}%`
    },
    prepareDate(date) {
      const d = new Date(date)

      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();

      return `${day}.${month}.${year}`;
    },
    prepareDates() {


      // Удаляем старые данные
      this.options.xaxis.categories.splice(0, this.options.xaxis.categories.length);

      const dates = this.statistic.array ? this.statistic.array.map(item => item.date) : [];

      // Добавляем нужные даны
      dates.forEach(date => {
        this.options.xaxis.categories.push(this.prepareDate(date));
      })
    },
    pushDateChart() {
      if (!this.statistic || !this.statistic.array) {
        return;
      }

      this.statistic.array ? this.statistic.array.forEach(item => {
        Object.keys(item).forEach(key => {
          const currentSeries = this.series.find(series => series.id === key);

          currentSeries ? currentSeries.data.push(item[key]) : null
        })
      }): null;

      this.key++
    },

    getCartProduct() {
      return this.$store.dispatch('getUniqueCartAddingProductList', {
        insales_id: this.insalesId,
        start: this.from.split('-').reverse().join('.'),
        end: this.to.split('-').reverse().join('.')
      }).then(response => response);
    }
  },
  mounted() {
    setTimeout(() => {
      this.prepareDates();
      this.pushDateChart()
    }, 500)
  }
}
</script>


<style lang="scss">
.period {
  background-color: var(--color-border);
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 30px;
  //max-width: 1000px;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  &_disabled {
    pointer-events: none;
    opacity: .3;
    position: relative;
    transition: .5s;

    &:after {
      backdrop-filter: blur(8px);
      z-index: 100;
      transition: .5s;
    }
  }

  &__tables {
    display: flex;
  }

  &__header {
    font-weight: 600;
    margin-bottom: 20px;
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }

  &__info {
    background-color: #fff;
    border-radius: 30px;
    width: fit-content;
    padding: 20px;
    margin: 0 10px 10px 0;
  }
  &__info-header {
    font-weight: 700;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }
  &__info-content {
    display: flex;
    align-items: center;
  }
  &__info-decor {
    display: block;
    margin: 0 5px;
  }


  &__popup {
    position: relative;
  }
  &__popup-trigger {
    display: block;

    width: 16px;
    height: auto;

    margin-left: 10px;
    cursor: pointer;

    &:hover + .period {
      &__popup-content {
        display: block;
      }
    }

    & svg {
      display: block;

      width: 16px;
      height: auto;

      & path {
        fill: #cacaca;
      }
    }
  }
  &__popup-content {
    display: none;

    position: absolute;
    background: #fff;
    padding: 15px;
    border: 1px solid var(--color-border);
    border-radius: 20px;
    width: 320px;
    font-size: 13px;
    font-weight: 500;
    z-index: 100;
    top: calc(100% + 10px);

    & p {
      margin-top: 0;
      margin-bottom: 6px;
    }
  }
}
</style>